<template>
    <CommonsMetaHead :meta="metaTags"/>
    <div class="">
        <div class="w-100 pt-4 desktop-desc">
            <MainSection :item="itemRef" :loading="loading" :attributes="attributes" :details="details"
                @selectFinishes="selectFinishes" :articles="content" :howToCare="howToCare"/>
        </div>
        <div class="w-100 pt-4 mobile-desc">
            <MainSectionMobile :item="itemRef" :loading="loading" :attributes="attributes" :details="details"
                @selectFinishes="selectFinishes" :articles="content" :howToCare="howToCare"/>
        </div>
        <div class="other-section desktop-desc">
            <BuyingChoice v-if="sourceType == 'item'" class="px-2 px-lg-5 px-md-5" ref="whyULoveIt" :item="itemRef" :section="addToCartSection" :finishes="finishes" />
            <BundleBuyingChoice v-else-if="sourceType == 'bundle'" class="px-2 px-lg-5 px-md-5" ref="whyULoveIt" :item="itemRef" :attachments="attachments" :section="addToCartSection" :finishes="finishes" />
            <!-- <RelatedBuyingChoice class="px-2 px-lg-5 px-md-5" ref="whyULoveIt" :section="mattressSection" />
            <RelatedBuyingChoice class="px-2 px-lg-5 px-md-5" ref="whyULoveIt" :section="beddingSection" />
            <RelatedBuyingChoice class="px-2 px-lg-5 px-md-5" ref="whyULoveIt" :section="materialSection" /> -->
            <!-- {{ pageRef }} -->
            <div class="mx-0 mx-lg-5 mx-md-5 my-4" v-if="pageRef.length">
                <p class="fs-6 my-4 ms-4">YOU MIGHT ALSO LIKE</p>
                <RelatedSection :items="pageRef" :loading="isFetchingRelatedItem" />
            </div>
        </div>
        <div class="other-section mobile-desc">
            <BuyingChoiceMobile v-if="sourceType == 'item'" class="px-2 px-lg-5 px-md-5" ref="whyULoveIt" :item="itemRef" :section="addToCartSection" :finishes="finishes" />
        </div>
    </div>
</template>

<script setup>
import MainSection from "@/views/detail-view/MainSection.vue";
import MainSectionMobile from "@/views/detail-view/MainSectionMobile.vue";
import BuyingChoice from "@/views/detail-view/component/BuyingChoice.vue";
import BuyingChoiceMobile from "@/views/detail-view/component/BuyingChoiceMobile.vue";
import BundleBuyingChoice from "@/views/detail-view/component/BundleBuyingChoice.vue";
import RelatedBuyingChoice from "@/views/detail-view/component/RelatedBuyingChoice.vue";

import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide, Pagination, Navigation } from "vue3-carousel";
import { itemsV3Client, cmsV2Client, kvpsClient } from "@/assets/apis/config";
import { Skeletor } from "vue-skeletor";
import "vue-skeletor/dist/vue-skeletor.css";
import RelatedSection from "../detail-view/component/RelatedSection.vue";
import { useMetaTagStore } from "@/stores/meta-tag-store";

const metaTagStore = useMetaTagStore();
const { $gtag } = useNuxtApp();
const props = defineProps({
    item: {
        type: Object,
        // default: null
    },
    loading: {
        type: Boolean,
        default: false
    },
    sourceType: {
        type: String,
        default: "item"
    },
    attachments: {
        type: Array,
        // default: null
    },
})
const itemRef = ref(null);
const whyULoveIt = ref(null);
const content = ref("");
const howToCare = ref("");
const details = ref([]);
const attributes = ref([]);
const pageRef = ref([]);
const isFetchingRelatedItem = ref(false);
const finishes = ref("");
const metaTagsList = ref([]);

const fetchMetaTags = async (id) => {
    // isLoading.value = true;
    let params = {
        textParams: [{
            field: 'type',
            value: `itemId_${id}`,
            matchType: 'EXACT',
        }],
        nestedParams: [],
        sortParams: [
            {
                field: 'title',
                type: 'ASCENDING',
            },
        ],
        page: 1,
        size: 100,
    };

    let res = await kvpsClient.search(params);
    console.log("kvpsClient res");
    console.log(res);
    if (res.status == 200 && !res.networkError && res?.body?.list) {
        console.log("tag res");
        console.log(res);
        metaTagsList.value = res?.body?.list;
    }
    // isLoading.value = false;
}

const metaTags = computed(() => {
    let title = "";
    let description = "";
    let image = "";
    let keywords = "";

    if (metaTagsList.value) {
        let descriptionMeta = metaTagsList.value.filter(i => i?.fields?.page && i?.fields?.page == 'description');
        if (descriptionMeta.length) {
            title = descriptionMeta[0]?.title;
            description = descriptionMeta[0]?.fields?.description;
            image = descriptionMeta[0]?.fields?.image;
            keywords = descriptionMeta[0]?.fields?.keywords;
        }
    }

    return {
        title: title,
        description: description,
        image: image,
        keywords: keywords,
    };
});

watch(metaTags,() => {
    if (metaTags.value?.title?.length) {
        useSeoMeta({
            title: metaTags.value?.title,
            ogTitle: metaTags.value?.title,
            description: metaTags.value?.description,
            keywords: metaTags.value?.keywords,
            ogDescription: metaTags.value?.description,
            ogImage: metaTags.value?.image,
        })
    }
},{deep: true})

// const relatedItems = ref([
//     {
//         url: "/images/landing/r-1.png",
//         title: "AKHTAR CLOSED BED SIDE TABLE",
//         price: "BDT 25900/-"
//     },
//     {
//         url: "/images/landing/r-2.png",
//         title: "AKHTAR CLOSED BED SIDE TABLE",
//         price: "BDT 25900/-"
//     },
//     {
//         url: "/images/landing/r-3.png",
//         title: "AKHTAR CLOSED BED SIDE TABLE",
//         price: "BDT 25900/-"
//     },
// ]);

const addToCartSection =ref({
    image: "/images/no-image.jpg",
    title: "AKHTAR BARAK OBAMA BED",
    configurePrice: "BDT 54999/-",
    firstPera: "",
    secondPera: "Headboard is an oversized piece that cannot be disassembled. We recommend measur",
    deliveryInfo: true,
    returnPolicy: true,
    returnPolicyText: "This item is special order and cannot be returned.",
    model: "AFL-BED-478",
});

const mattressSection =ref({
    image: "/images/no-image.jpg",
    title: "AKHTAR ROYAL POCKET SPRING MATTRESS",
    configurePrice: "BDT48999/-",
    firstPera: "",
    secondPera: "",
    deliveryInfo: true,
    returnPolicy: true,
    returnPolicyText: "",
    model: "AFL-FAB2312",
    selector: {
        size: true,
        comfort: true,
    }
});

const beddingSection =ref({
    image: "/images/no-image.jpg",
    title: "AFL BEDDING",
    configurePrice: "BDT 9799/-",
    firstPera: "Leather options vary by collection",
    secondPera: "Swatches are shipped at no charge. For free USPS expedited delivery to arrive within 2-3 business days, all swatches must be placed in a separate order from product orders.",
    deliveryInfo: true,
    returnPolicy: true,
    returnPolicyText: "This item can be returned within 30 days of delivery.",
    model: "AFL-FAB2312",
    selector: {
        item: true,
        fabric: true,
        color: true,
    }
});

const materialSection =ref({
    image: "/images/no-image.jpg",
    title: "WOOD MATERIAL",
    configurePrice: "BDT 9799/-",
    firstPera: "Leather options vary by collection",
    secondPera: "Swatches are shipped at no charge. For free USPS expedited delivery to arrive within 2-3 business days, all swatches must be placed in a separate order from product orders.",
    deliveryInfo: false,
    returnPolicy: false,
    returnPolicyText: "This item can be returned within 30 days of delivery.",
    model: "AFL-FAB2312",
    selector: {
        material: true,
    }
});

const selectFinishes = (item) => {
    finishes.value = item.toLowerCase();
}

const category = computed(() => {
    let parentCate = null;
    let parentChildCate = null;
    let childCate = null;
    if (
        itemRef.value &&
        itemRef.value.categories &&
        itemRef.value.categories.length > 0
    ) {
        
        let hasParentCate = itemRef.value.categories.filter(
            (i) => !i.parentId.length
        );
        if (hasParentCate.length > 0) {
            parentCate = {
                categoryName: hasParentCate[0].name,
                categoryId: hasParentCate[0].id,
                parentId: "",
                parentName: "",
            };
            let hasParentChildCate = itemRef.value.categories.filter(
                (i) => i.parentId.length && i.parentId == hasParentCate[0].id
            );
            if (hasParentChildCate.length > 0) {
                parentChildCate = {
                    categoryName: hasParentChildCate[0].name,
                    categoryId: hasParentChildCate[0].id,
                    parentId: parentCate != null ? parentCate.categoryId : "",
                    parentName: parentCate != null ? parentCate.categoryName : "",
                };
                let hasChildCate = itemRef.value.categories.filter(
                    (i) => i.parentId.length && i.parentId == hasParentChildCate[0].id
                );
                if (hasChildCate.length > 0) {
                    childCate = {
                        categoryName: hasChildCate[0].name,
                        categoryId: hasChildCate[0].id,
                        parentId: parentCate != null ? parentCate.categoryId : "",
                        parentName: parentCate != null ? parentCate.categoryName : "",
                    };
                }
            }
        } else {
            parentCate = {
                categoryName: itemRef.value.categories[0].name,
                categoryId: itemRef.value.categories[0].id,
                parentId: "",
                parentName: "",
            };
        }
    }
    return {
        parent: parentCate,
        parentChild: parentChildCate,
        child: childCate,
    };
});

// const fetchArticles = (id) => {
//     cmsV2Client.fetchArticles({ itemId: id }).then((res) => {
//         if (res.status == 200 && !res.networkError) {
//             if (res.body && res.body.content && res.body.content.length > 0) {
//                 content.value = res.body.content;
//             }
//         }
//     });
// };

const fetchArticles = async (id) => {
    let req = {
        textParams: [
            {
                field: 'itemId',
                value: id,
                matchType: 'EXACT'
            }
        ],
        page: 1,
        size: 10
    }
    
    let res = await cmsV2Client.fetchArticles(req);

    if (res.status == 200 && !res.networkError) {
        if (res?.body?.list?.length) {
            content.value = res.body.list.filter(a => a.type == 'short-description')[0]?.content;
            howToCare.value = res.body.list.filter(a => a.type == 'how-To-Care')[0]?.content;
        }
    }
};

const fetchDetails = (id) => {
    cmsV2Client.fetchBulletPoints({ itemId: id, size: 50 }).then((res) => {
        if (res.status == 200 && !res.networkError) {
            if (res.body && res.body.list && res.body.list.length > 0) {
                let newVal = [];
                let list = res.body.list.sort((x, y) => x.seq - y.seq);
                list.forEach((val, index) => {
                    if (val.point && val.point.length > 0) {
                        newVal.push({
                            points: val.point,
                            lastIndex: val.seq,
                        });
                    }
                });
                details.value = newVal;
            }
        }
    });
};

const fetchDimensions = (id) => {
    cmsV2Client.fetchAttributes({ itemId: id }).then((res) => {
        if (res.status == 200 && !res.networkError) {
            let newVal = [];
            let body = res.body;
            if (body.textAttributes) {
                let keys = Object.keys(body.textAttributes);
                keys.forEach((key, index) => {
                    if (key.includes("image_")) {
                        let hasImage = newVal.findIndex(
                            (i) => i.type == "dimension_image"
                        );
                        if (hasImage > -1) {
                            newVal[hasImage][key] = body.textAttributes[key];
                        } else {
                            newVal.push({
                                type: "dimension_image",
                                image_1:
                                    key == "image_1"
                                        ? body.textAttributes[key]
                                        : "",
                                image_2:
                                    key == "image_2"
                                        ? body.textAttributes[key]
                                        : "",
                            });
                        }
                    } else {
                        if (body.textAttributes[key].length > 0) {
                            newVal.push({
                                field: key,
                                value: body.textAttributes[key],
                            });
                        }
                    }
                });
            }
            attributes.value = newVal;
        }
    });
};
const fetchRelatedItems = async (id) => {
    let param = {
        textParams: [],
        page: 1,
        size: 18,
    };

    if (id?.length) {
        param.textParams.push(
            {
                field: 'sourceId',
                value: id,
                matchType: "EXACT"
            }
        )

        param.textParams.push(
            {
                field: 'sourceType',
                value: 'ITEM',
                matchType: "EXACT"
            }
        )
    }

    isFetchingRelatedItem.value = true;
   
    let res = await itemsV3Client.fetchRelatedProduct(param);
    // console.log("related product res");
    // console.log(res);
    if (res.status == 200 && !res.networkError) {
        pageRef.value = res?.body?.list;
        // totalItems.value = res?.body?.total;
        // currentPage.value = params.page;
        // totalPages.value = Math.round(totalItems.value / 18);
    }
    isFetchingRelatedItem.value = false;
}
// const fetchRelatedItems = async (cate) => {
//     isFetchingRelatedItem.value = true;
//     let hasSatisfied = false;

//     if (cate && cate && cate.length > 0) {
//         let cateV2 =
//             category.value &&
//             category.value.parentChild &&
//             category.value.parentChild.categoryName &&
//             category.value.parentChild.categoryName.length > 0
//                 ? category.value.parentChild.categoryName
//                 : cate;
//         // const req = {
//         //     page: 1,
//         //     size: 20,
//         //     categories:
//         //         cateV2 && cateV2 && cateV2.length > 0 ? [cateV2.trim()] : [],
//         //     sortParams: [
//         //         {
//         //             field: "dateCreated",
//         //             type: "DESCENDING",
//         //         },
//         //         {
//         //             field: "title",
//         //             type: "ASCENDING",
//         //         },
//         //     ],
//         // };
//         let req = {
//             query: "",
//             filters: [{
//                 field: 'categoryIds',
//                 values: [cate]
//             }],
//             // status: selectedStatus.value,
//             nonZeroStockOnly: false,
//             page: 1,
//             size: 10,
//         };
//         let nextPageToken = "";
//         let res = await itemsV3Client.search(req);

//         // do {
//         //     let res = await productsClient.search(req);

//         //     if (!res.networkError && res.status == 200) {
//         if (res?.body?.list?.length) {

//             let list = res.body.list.filter((i) => i.id != itemRef.value.id);

//             list = list.filter((value, index, self) => index === self.findIndex((t) => t.id === value.id));
            
//             pageRef.value = list;

//             // if (
//             //     res.body.nextPageToken &&
//             //     res.body.nextPageToken.length > 0
//             // ) {
//             //     req.page++;
//             // }

//             // hasSatisfied =
//             //     res.body.list.length == req.size ? true : false;
//         }
//         // nextPageToken = res.body.nextPageToken;
//             // }
//         isFetchingRelatedItem.value = false;
//         // } while (nextPageToken.length > 0 && !hasSatisfied);
//     }
// };
const findLastChild = (categories) => {
  let lastChild = null;

  if (categories.length) {
    categories.forEach(category => {
      const hasChildren = categories.some(c => c.parentId === category.id);
      if (!hasChildren) {
        lastChild = category;
      }
    });
  }

  return lastChild;
};

watch(() => props.item,
    () => {
        if (props.item != null) {
            itemRef.value = props.item;
            let title = itemRef.value?.title;
            let id = itemRef.value?.id;
            addToCartSection.value.title = title;
            addToCartSection.value.image = itemRef.value?.images?.length ? itemRef.value?.images[0].url : '';
            addToCartSection.value.configurePrice = itemRef.value?.skus?.length ? `BDT ${itemRef.value?.skus[0].salesPrice}/-` : `BDT 0/-`;
            fetchArticles(itemRef.value.id);
            fetchDetails(itemRef.value.id);
            fetchDimensions(itemRef.value.id);
            fetchRelatedItems(itemRef.value.id);
            fetchMetaTags(itemRef.value.id);
            if (process.client && id?.length) {
                $gtag('event', 'product_view', {
                    'product_id': id,
                    'product_title': title,
                });
            }
            // let hasChildCate = itemRef.value.categories.filter(
            //     (i) => i.childCount == 0
            // );
            // let hasChildCate = findLastChild(itemRef.value.categories)
            
            // console.log("itemRef.value.categories");
            // console.log(hasChildCate);
            // if (hasChildCate?.name?.length) {
            //     console.log(hasChildCate);
            //     fetchRelatedItems(hasChildCate.id);
            // }
        }
    },
    { immediate: true },
    { deep: true }
);

onMounted(async () => {
    // pageRef.value = await setLoading();
});
</script>

<style lang="scss">
.tab-active {
    color: #F69320;
    transition: 0.3s;
    text-align: center;
    padding: 10px 0px;
    cursor: pointer;
    width: 100%;
    border-bottom: 2px solid #F69320;
}

.bottom-btn {
    text-align: center;
    font-size: 16px;
    padding: 10px 0px;
    height: 50px;
    cursor: pointer;
}

.bottom-btn:hover {
    color: #F69320;
    transition: 0.3s;
    text-align: center;
    padding: 10px 0px;
}

.details-page-related-section {

    .carousel__prev,
    .carousel__next {
        margin: 0px -5% !important
    }
}

.desktop-desc {
    display: block;
}
.mobile-desc {
    display: none !important;
}
@media screen and (max-width: 767px) {
    .desktop-desc {
        display: none !important;
    }
    .mobile-desc {
        display: flex !important;
    } 
}

.desktop-buying-choice {
    display: block;
}
.mobile-buying-choice {
    display: none !important;
}
@media screen and (max-width: 767px) {
    .desktop-buying-choice {
        display: none !important;
    }
    .mobile-buying-choice {
        display: block !important;
    } 
}
</style>
